var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDayCurrentInvert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 19,
    viewBox: "0 0 74 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 36.8,
    y1: 46.421,
    x2: 36.8,
    y2: -51.612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFB739",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 -0 -1 74 19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.35866 18.6L0 11.7705L0 0L73.6 0L73.6 11.7705L67.2413 18.6L51.8848 18.6L21.7152 18.6L6.35866 18.6L6.35866 18.6Z",
    fill: "url(#gradient_1)",
    strokeWidth: 0.4,
    stroke: "#FFB739",
    transform: "translate(0.2 0.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDayCurrentInvert);
export default __webpack_public_path__ + "static/media/iconDayCurrent_invert.3d3058284b509584c9ca33a8f3787ecc.svg";
export { ForwardRef as ReactComponent };